import React from 'react';

import { renderMoneyAmountShort } from '../../components/formBuilder/utility/renderValue';
import BRRRRInvestmentCriteria from './BRRRRInvestmentCriteria';
import ClearBadge from '../../components/property-summaries/ClearBadge';
import Tooltip from '../../components/Tooltip';

export default function BRRRRKeyMetrics({ propertyData, scenarioData }) {
  const merged = { ...propertyData, ...scenarioData };
  const newValue = merged.newMarketValue;
  const valueIncrease = merged.forcedAppreciation;
  const newEquityAfterRehab = merged.equityInProperty;
  const equityPurchase = merged.equityOnPurchase;
  const equityDifference = newEquityAfterRehab - equityPurchase;

  return (
    <section className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
      <div className="relative">
        <div className="rounded-lg relative bg-white p-8 flex items-center justify-center gap-2 overflow-hidden h-full">
          <div
            className={`w-1.5 h-full absolute left-0 top-0 ${
              newValue >= 0 ? 'bg-primary-500' : 'bg-warning-500'
            }`}
          ></div>
          <div className="flex flex-col items-start">
            <h3 className="text-md text-neutral-600">Value after Refinance</h3>
            <div className="flex items-center gap-2 printing-text-spacing">
              <p className="text-6xl font-serif text-neutral-900 font-medium">
                {renderMoneyAmountShort(newValue)}
              </p>
              <ClearBadge amount={valueIncrease}>
                {renderMoneyAmountShort(valueIncrease, true)}
              </ClearBadge>
            </div>
          </div>
        </div>
        <div className="absolute top-3 right-3">
          <Tooltip
            type="info"
            heading="New Value"
            text="The estimated market value of the property after the rehab"
          />
        </div>
      </div>
      <div className="relative">
        <div className="rounded-lg relative bg-white p-6 flex items-center justify-center gap-2 overflow-hidden h-full">
          <div
            className={`w-1.5 h-full absolute left-0 top-0 ${
              newEquityAfterRehab >= 0 ? 'bg-primary-500' : 'bg-warning-500'
            }`}
          ></div>
          <div className="flex flex-col items-start">
            <h3 className="text-md text-neutral-600">Equity after Refinance</h3>
            <div className="flex items-center gap-2 printing-text-spacing">
              <p className="text-6xl font-serif text-neutral-900 font-medium">
                {renderMoneyAmountShort(newEquityAfterRehab)}
              </p>
              <ClearBadge amount={equityDifference}>
                {renderMoneyAmountShort(equityDifference, true)}
              </ClearBadge>
            </div>
          </div>
        </div>
        <div className="absolute top-3 right-3">
          <Tooltip
            type="info"
            heading="New Equity"
            text="The new equity in the property after refinancing"
            formula={['New Equity', '=', 'New Value', '-', 'New Loan']}
          />
        </div>
      </div>
      <BRRRRInvestmentCriteria
        propertyData={propertyData}
        scenarioData={scenarioData}
      />
    </section>
  );
}
